import state from './state'

export default {
    getBulkReport() {
      return state.bulkReport;
    },
  
    getTotalPages() {
      return state.totalPage;
    },

    getTotal() {
      return state.totalItems;
    },

    getBulkAutoSubstitutingReport() {
        return state.bulkAutoSubstitutingReport;
    },

    getTotalAutoSubstitutingPages() {
        return state.autoSubstitutingTotalPage;
    },

    getTotalAutoSubstituting() {
        return state.autoSubstitutingTotalItems;
    },

    getBulkSms() {
        return state.bulkSms;
    },

    getTotalBulkSmsPages() {
        return state.bulkSmsTotalPage;
    },

    getTotalBulkSms() {
        return state.autoSubstitutingTotalItems;
    },

  
};